import type { IFetcher } from "../util/io/Fetcher";
import type { StudyUploadRequestModel, UploadCompleteRequestModel, UploadCompleteResultModel } from "../../OpenApi/api";

export interface IPatientUploadCompleteCallbackStore {
    completeUpload(
        sourceId: number,
        uploadCode: string | null,
        emailAddress: string | null,
        mobilePhone: string | null,
        studyInfo: StudyUploadRequestModel[],
    ): Promise<UploadCompleteResultModel>;
}

export class PatientUploadCompleteCallbackStore implements IPatientUploadCompleteCallbackStore {
    private static readonly Url: string = "/POW4/Upload/Complete";

    constructor(private readonly _fetcher: IFetcher) {}

    public async completeUpload(
        sourceId: number,
        uploadCode: string | null,
        emailAddress: string | null,
        mobilePhone: string | null,
        studyInfo: StudyUploadRequestModel[],
    ): Promise<UploadCompleteResultModel> {
        const { _fetcher } = this;
        const request: UploadCompleteRequestModel = {
            sourceId: sourceId,
            dicomUploadCode: uploadCode,
            emailAddress: emailAddress,
            mobilePhone: mobilePhone,
            studyInfo: studyInfo,
        };
        return await _fetcher.postJSON<UploadCompleteResultModel>(PatientUploadCompleteCallbackStore.Url, request);
    }
}
